import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { v4 as uuidv4 } from 'uuid';
import i18n, { SettingsType } from 'utils/i18n';
import Settings from './settings';
import Link from 'next/link';

export const LandingSignin: React.FC = () => {
  const { locale } = useRouter();
  const { footerlinks } = i18n[(locale as AcceptedLocales) || 'en-US'];
  const keys = useMemo(() => footerlinks.map(() => uuidv4()), [footerlinks]);

  return (
    <footer className="bg-footer w-full h-nav flex justify-center border-t border-border">
      <div className="w-full flex items-center justify-between outer-padding">
        <Settings />
        <ul className="flex flex-wrap gap-x-10 items-center">
          {footerlinks.map((link, index: number) => (
            <li key={keys[index]} className="">
              <Link href={link.href} passHref>
                <a>
                  <span className="text-sm text-textRegular flex items-center font-normal">{link.name}</span>
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
};

export default LandingSignin;
